import React from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  Stack,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";

const SimpleConfirmDialog = ({
  open,
  onClose,
  header,
  dateLine,
  body,
  loading,
  onConfirm,
  acceptRegulamin,
  setAcceptRegulamin,
  lessonData,
  AcceptRegulaminLabel,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      fullWidth 
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 2,
          m: isMobile ? 2 : 3,
        }
      }}
    >
      <DialogTitle sx={{ 
        textAlign: 'center', 
        pb: 1,
        pt: 3,
      }}>
        <Typography variant={isMobile ? "h6" : "h5"} fontWeight="600" gutterBottom>
          {header}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {dateLine}
        </Typography>
      </DialogTitle>
      
      <DialogContent sx={{ pt: 2, pb: 3 }}>
        <Stack spacing={2.5}>
          {/* Location information */}
          {lessonData?.lesson_type?.location && (
            <Card elevation={0} sx={{ backgroundColor: '#f5f5f5', borderRadius: 2 }}>
              <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
                <Stack direction="row" spacing={1.5} alignItems="center">
                  <Box sx={{ fontSize: '1.25rem' }}>📍</Box>
                  <Box>
                    <Typography variant="body2" fontWeight="500">
                      {lessonData.lesson_type.location.name || 'Lokalizacja'}
                    </Typography>
                    {lessonData.lesson_type.location.address && (
                      <Typography variant="caption" color="text.secondary">
                        {lessonData.lesson_type.location.address}
                      </Typography>
                    )}
                  </Box>
                </Stack>
              </CardContent>
            </Card>
          )}
          
          <Typography variant="body1" sx={{ px: 1 }}>
            {body}
          </Typography>
          
          <Divider />
          
          <FormControlLabel
            control={
              <Checkbox 
                checked={acceptRegulamin} 
                onChange={(e) => setAcceptRegulamin(e.target.checked)} 
              />
            }
            label={AcceptRegulaminLabel}
            sx={{ mx: 0 }}
          />
        </Stack>
      </DialogContent>
      
      <DialogActions sx={{ 
        px: 3, 
        pb: 3, 
        gap: 1,
        flexDirection: isMobile ? 'column' : 'row'
      }}>
        <Button 
          onClick={onClose} 
          variant="outlined"
          fullWidth={isMobile}
          sx={{ minHeight: 44 }}
        >
          Anuluj
        </Button>
        <Button 
          onClick={onConfirm} 
          color="success" 
          variant="contained" 
          disabled={loading || !acceptRegulamin}
          fullWidth={isMobile}
          sx={{ minHeight: 44 }}
        >
          {loading ? <CircularProgress size={20} color="inherit" /> : "Zapisz się"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SimpleConfirmDialog;
